module.exports = __webpack_public_path__ + "static/media/nbc.32a75d81.png";